{
  "runners": {
    "player_0": {
      "px": 2,
      "faces": {
        "calm": "chars/runner3/head_calm.webp",
        "determined": "chars/runner3/head_determined.webp",
        "surprised": "chars/runner3/head_surprised.webp",
        "dizzy": "chars/runner3/head_dizzy.webp",
        "overjoyed": "chars/runner3/head_overjoyed.webp"
      },
      "headPivot": [46.9, 76.8],
      "crown": [40.8, 6.1],
      "eyes": [57.1, 34.6],
      "torso": {
        "src": "chars/runner3/torso.webp",
        "pivot": [12.3, 29.3],
        "neck": [13.1, 1.6],
        "shoulder": [15.1, 8.0],
        "back": [5.6, 9.6]
      },
      "arm": {
        "src": "chars/runner3/arm.webp",
        "pivot": [6.4, 2.1]
      },
      "leg": {
        "src": "chars/runner3/leg.webp",
        "pivot": [6.8, 2.1]
      }
    },
    "player_1": {
      "px": 2,
      "faces": {
        "calm": "chars/runner4/head_calm.webp",
        "determined": "chars/runner4/head_determined.webp",
        "surprised": "chars/runner4/head_surprised.webp",
        "dizzy": "chars/runner4/head_dizzy.webp",
        "overjoyed": "chars/runner4/head_overjoyed.webp"
      },
      "headPivot": [27.2, 76.8],
      "crown": [26.0, 6.1],
      "eyes": [36.4, 34.6],
      "torso": {
        "src": "chars/runner4/torso.webp",
        "pivot": [9.3, 29.3],
        "neck": [9.2, 1.6],
        "shoulder": [10.7, 8.0],
        "back": [3.4, 9.6]
      },
      "arm": {
        "src": "chars/runner4/arm.webp",
        "pivot": [5.3, 2.1]
      },
      "leg": {
        "src": "chars/runner4/leg.webp",
        "pivot": [6.0, 2.1]
      }
    }
  },
  "costumes": {
    "cos_hat_beanie": {
      "slot": "hat",
      "pieces": {
        "head": {
          "src": "costumes/hat/beanie.webp",
          "pivot": [32.0, 35.5],
          "at": "crown"
        }
      }
    },
    "cos_hat_chef": {
      "slot": "hat",
      "pieces": {
        "head": {
          "src": "costumes/hat/chef.webp",
          "pivot": [30.0, 36.4],
          "at": "crown"
        }
      }
    },
    "cos_face_star_shades": {
      "slot": "face",
      "pieces": {
        "head": {
          "src": "costumes/face/star_shades.webp",
          "pivot": [21.6, 10.5],
          "at": "eyes"
        }
      }
    },
    "cos_face_snorkel": {
      "slot": "face",
      "pieces": {
        "head": {
          "src": "costumes/face/snorkel.webp",
          "pivot": [40.0, 23.4],
          "at": "eyes"
        }
      }
    },
    "cos_back_leaf_cape": {
      "slot": "back",
      "pieces": {
        "torso": {
          "src": "costumes/back/leaf_cape.webp",
          "pivot": [35.2, 3.1]
        }
      }
    },
    "cos_back_shard_pack": {
      "slot": "back",
      "pieces": {
        "torso": {
          "src": "costumes/back/shard_pack.webp",
          "pivot": [20.6, 10.3]
        }
      }
    }
  },
  "rides": {
    "ride_jet_snail": {
      "seat": [136.0, 67.0]
    },
    "ride_thundertoad": {
      "seat": [108.5, 51.5]
    },
    "ride_wobblebot": {
      "seat": [102.0, 15.0]
    },
    "ride_pufferloon": {
      "seat": [118.0, 32.0]
    },
    "ride_drillmole": {
      "seat": [83.0, 91.0]
    },
    "ride_crabwalker": {
      "seat": [96.0, 99.0]
    }
  }
}
